import React, { memo } from "react";
import { Grid } from "@sumprio/ui";
import { AvatarNameRow } from "../AvatarNameRow";
import { ChatConversationPanel } from "../ChatConversationPanel";
import type { ChatConversationPanelProps } from "../ChatConversationPanel";

export interface ChatThreadWithHeaderProps extends ChatConversationPanelProps {
  peerDisplayName: string;
  peerInitials: string;
  peerSecondaryText?: string;
  peerAvatarSrc?: string | null;
  headerRight?: React.ReactNode;
  onPeerHeaderClick?: () => void;
  peerHeaderAriaLabel?: string;
  composerError?: React.ReactNode;
}

function ChatThreadWithHeader({
  peerDisplayName,
  peerInitials,
  peerSecondaryText,
  peerAvatarSrc,
  headerRight,
  onPeerHeaderClick,
  peerHeaderAriaLabel,
  composerError,
  ...conversationProps
}: ChatThreadWithHeaderProps) {
  return (
    <Grid
      display="flex"
      flexDirection="column"
      flex={1}
      width="100%"
      gap={0}
      style={{ minHeight: 0 }}
    >
      <Grid
        display="flex"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        borderBottom="1px solid var(--color-border-neutral-primary)"
        paddingX="xl"
        paddingBottom="md"
        flexShrink={0}
      >
        <Grid display="flex" flex={1} minWidth={0} alignItems="center">
          <AvatarNameRow
            initials={peerInitials}
            value={peerDisplayName}
            secondaryText={peerSecondaryText}
            avatarSize="md"
            gap="md"
            avatarSrc={peerAvatarSrc}
            {...(onPeerHeaderClick
              ? {
                  onClick: onPeerHeaderClick,
                  ariaLabel: peerHeaderAriaLabel,
                }
              : {})}
          />
        </Grid>
        {headerRight !== null && headerRight !== undefined ? headerRight : null}
      </Grid>

      {composerError !== null && composerError !== undefined ? (
        <Grid flexShrink={0} paddingX="xl">
          {composerError}
        </Grid>
      ) : null}

      <ChatConversationPanel {...conversationProps} />
    </Grid>
  );
}

const ChatThreadWithHeaderMemo = memo(ChatThreadWithHeader);
ChatThreadWithHeaderMemo.displayName = "ChatThreadWithHeader";
export default ChatThreadWithHeaderMemo;
